import axios from '@axios'

// Use the URL from the provided cURL for now
const CREATIVE_SERVICE_URL = process.env.VUE_APP_CREATIVE_SERVICE_URL

export default {
  /**
   * Get avatar list with pagination
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number (default: 1)
   * @param {number} params.limit - Items per page (default: 30)
   * @returns {Promise<Object>} Avatar list response
   */
  getAvatarList(params = {}) {
    const { page = 1, limit = 30 } = params

    // Build query string using URLSearchParams
    const searchParams = new URLSearchParams()
    searchParams.append('page', String(page))
    searchParams.append('limit', String(limit))

    const url = `${CREATIVE_SERVICE_URL}/api/creative/avatar/list?${searchParams.toString()}`
    return axios.get(url)
  },
}
